module.exports = __webpack_public_path__ + "img/ic_liveticker_card_yellow.e5ffb5fb.svg";